import {classNames} from "../../providers/utils";
import React from "react";
import {ProductProps} from "./Product";

export const ProductImageGrid = ({product}: ProductProps) => {
    return(
        <div className="grid grid-cols-1 lg:grid-cols-2 lg:grid-rows-3 lg:gap-8">
            {(product.images || []).map((image: string) => (
                <img
                    key={image}
                    src={image}
                    alt={product.title}
                    className={classNames('hidden lg:block', 'rounded-lg')}
                />
            ))}
        </div>
)
}